import axios from '@/apps/open/utils/axios'

const isPrivate = process.env.VUE_APP_IS_PRIVATE

let companyId = 671085136
const origin = isPrivate ? '' : '/3rd'

export function setCompanyId (company_id) {
  ~company_id && (companyId = company_id)
}

/**
 * 获取部门列表
 * @param companyId
 */
export function getDepartmentList (parentId = 0, isCatchError = true, isSendMessage = false) {
  const query = {
    comp_id: companyId,
    parent_id: parentId
  }
  return axios({
    url: `${origin}/plussvr/api/${companyId}/department/curlevel`,
    method: 'get',
    params: query,
    isCatchError,
    isSendMessage,
    timeout: 0 // 默认无超时限制
  })
}

/**
 * 获取部门成员
 * @param query
 */
export function getDepartmentMemberList (query, isCatchError = true, isSendMessage = false) {
  return axios({
    url: `${origin}/plussvr/api/${companyId}/dept/users`,
    method: 'get',
    params: query,
    isCatchError,
    isSendMessage
  })
}

/**
 * 搜索企业成员
 * @param query
 */
export function getCompanyMemberList (query, isCatchError = true, isSendMessage = false) {
  query.cropids = companyId
  return axios({
    url: `${origin}/drive/api/v3/search/company/${companyId}/members`,
    method: 'get',
    params: query,
    isCatchError,
    isSendMessage
  })
}
